<template>
  <button class="product-card-cart-like"
          @click="addToWishlist"
          aria-label="Add to your favourites"
          :disabled="wishlistProcessing">
    <i :class="favouriteState"></i>
  </button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "addToWishlistV2",
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      wishlistProcessing: false,
    }
  },
  computed: {
    ...mapGetters([
      'inWishlist'
    ]),
    favouriteState() {
      return this.inWishlist(this.id) ? "zmdi zmdi-favorite" : "zmdi zmdi-favorite-outline";
    },
  },
  methods: {
    ...mapActions(['triggerAddToWishlist']),
    addToWishlist() {
      // Do not process until it's completed
      if (this.wishlistProcessing) {
        return;
      }

      this.wishlistProcessing = true;
      this.triggerAddToWishlist({
        id: this.id,
        title: this.title,
        callback: () => this.wishlistProcessing = false,
      })
    },
  },
}
</script>
